<template>
  <div class="header" :data-theme="$store.state.dataTheme">
    <!-- <div class="head" :data-theme="$store.state.dataTheme">
      <div class="head-inner">
        <div class="login">
          <el-popover placement="bottom" trigger="click">
            <div class="user-defined">
              <el-switch
                v-model="gray"
                active-color="#42a1ff"
                inactive-color="#999"
                active-text="无色"
                @change="grayHandleChange"
              ></el-switch>
            </div>
            <div class="user-defined">
              <el-radio-group v-model="dataTheme" size="mini" @change="dataThemeHandleChange">
                <el-radio-button label="default">默认</el-radio-button>
                <el-radio-button label="national">中国红</el-radio-button>
                <el-radio-button label="dark">暗黑</el-radio-button>
              </el-radio-group>
            </div>
            <template v-for="item in templates">
              <template v-if="item.name === 'newsboard'">
                <div :key="item.id" class="user-defined">
                  <el-switch
                    v-model="item.show"
                    active-color="#42a1ff"
                    inactive-color="#999"
                    active-text="新闻动态"
                  ></el-switch>
                  <template v-if="item.show">
                    <div class="user-defined">
                      <el-switch
                        v-model="item.imgNews"
                        active-color="#42a1ff"
                        inactive-color="#999"
                        active-text="新闻轮播"
                      ></el-switch>
                    </div>
                    <div class="user-defined">
                      <el-switch
                        v-model="item.textNews"
                        active-color="#42a1ff"
                        inactive-color="#999"
                        active-text="新闻列表"
                      ></el-switch>
                    </div>
                  </template>
                </div>
              </template>
              <template v-else-if="item.name === 'drill-column'">
                <div :key="item.id" class="user-defined">
                  <el-switch
                    v-model="item.show"
                    active-color="#42a1ff"
                    inactive-color="#999"
                    active-text="训练专栏"
                  ></el-switch>
                </div>
              </template>
              <template v-else-if="item.name === 'training'">
                <div :key="item.id" class="user-defined">
                  <el-switch
                    v-model="item.show"
                    active-color="#42a1ff"
                    inactive-color="#999"
                    active-text="微警校"
                  ></el-switch>
                </div>
              </template>
              <template v-else-if="item.name === 'test-center'">
                <div :key="item.id" class="user-defined">
                  <el-switch
                    v-model="item.show"
                    active-color="#42a1ff"
                    inactive-color="#999"
                    active-text="考试中心"
                  ></el-switch>
                </div>
              </template>
              <template v-else-if="item.name === 'drillmaster'">
                <div :key="item.id" class="user-defined">
                  <el-switch
                    v-model="item.show"
                    active-color="#42a1ff"
                    inactive-color="#999"
                    active-text="优秀教官"
                  ></el-switch>
                </div>
              </template>

              <template v-else-if="item.name === 'ranking-list'">
                <div :key="item.id" class="user-defined">
                  <el-switch
                    v-model="item.show"
                    active-color="#42a1ff"
                    inactive-color="#999"
                    active-text="排行榜"
                  ></el-switch>
                </div>
              </template>
            </template>
            <button slot="reference">自定义</button>
          </el-popover>
          <button @click="clickBtn('approve')">PKI认证</button>
          <button @click="clickBtn('login')">登录</button>
        </div>
      </div>
    </div>-->

    <!--  -->

    <div class="banner" :style="'background-image:url(' + bannerUrl + ')'">
      <img class="logoleft" src="@/assets/images/home/logo.png" :draggable="false" />
      <div class="bannerTitle">
        <div class="txt-title txt">
          <!-- 学堂科技 -->
          <div class="fonttext">{{biaoTi}}</div>
          <div class="botn">education and training network college</div>
        </div>
      </div>
      <!-- <div class="bannerInput">
        <input type="search" class="inputseach" placeholder="请输入您要搜索的内容" v-model="keyworks" />
        <div class="inputimg" @click="searcha">搜索</div>
      </div>-->
    </div>
    <div class="nav" :data-theme="$store.getters.dataTheme">
      <ul>
        <router-link
          v-for="(item, index) in navs"
          :key="index"
          :to="item.path"
          tag="li"
          :class="{ active: index === 0 }"
        >{{ item.title }}</router-link>
      </ul>
    </div>

    <!-- 登录悬浮 -->
    <!-- <login></login> -->
    <transition name="slide-right">
      <div class="logsuspend">
        <ul class="logsupendul" v-if="backflag==true">
          <li
            class="logsupendli"
            @mouseenter="changeImageSrc(1, 'hover')"
            @mouseleave="changeImageSrc(1, '')"
            @click.stop="clickBtnlist('login')"
            v-if="!tokenn"
          >
            <div class="logsupendli-center">
              <img :src="prevImg01" alt />
              <span>登录</span>
            </div>
          </li>

          <!-- <li
            class="logsupendli"
            @mouseenter="changeImageSrc(2, 'hover')"
            @mouseleave="changeImageSrc(2, '')"
            v-if="!tokenn"
          >
            <div class="logsupendli-center">
              <img :src="prevImg02" alt />
              <span>注册</span>
            </div>
          </li>-->

          <li
            style="height:120px"
            class="logsupendli"
            @mouseenter="changeImageSrc(5, 'hover')"
            @mouseleave="changeImageSrc(5, '')"
            v-if="tokenn"
          >
            <div class="logsupendli-center" @click="personCenter()">
              <img :src="person.photo" alt style="width:40px;height:40px;border-radius: 50%;" />
              <div style="font-size:12px;margin-top:13px">{{person.name}}</div>
              <span style="font-size:10px">个人中心</span>
            </div>
          </li>

          <!-- <li
            class="logsupendli"
            @mouseenter="changeImageSrc(3, 'hover')"
            @mouseleave="changeImageSrc(3, '')"
          >
            <div class="logsupendli-center">
              <img :src="prevImg03" alt />
              <span>手机APP</span>
            </div>
          </li>-->

          <!-- <li
            class="logsupendli"
            @mouseenter="changeImageSrc(2, 'hover')"
            @mouseleave="changeImageSrc(2, '')"
            @click="goSystiem()"
            v-if="tokenn"
          >
            <div class="logsupendli-center">
              <img :src="prevImg02" alt />
              <span>后台管理</span>
            </div>
          </li>-->
          <li
            class="logsupendli"
            @mouseenter="changeImageSrc(5, 'hover')"
            @mouseleave="changeImageSrc(5, '')"
            @click="goOut()"
            v-if="tokenn"
          >
            <div class="logsupendli-center">
              <!-- <img :src="prevImg02" alt /> -->
              <span>退出登录</span>
            </div>
          </li>
          <div
            class="logsupendli logsupendli7"
            @mouseenter="changeImageSrc(4, 'hover')"
            @mouseleave="changeImageSrc(4, '')"
            @click="takeback()"
          >
            <div class="logsupendli-center">
              <img :src="prevImg04" alt />
            </div>
          </div>
        </ul>
        <div @click="takeback()" v-if="backflag==false" class="jiantou">
          <img class="arrowsleft" src="@/assets/images/home/chevron-back-outline.svg" />
        </div>

        <div class="phoneapp" v-if="moovflag">
          <!-- <img src="@/assets/APP二维码.png" /> -->
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { getInfo, removeInfo } from '@/utils/auth';
// import login from '../smallHeader/login'
export default {
  // components:{
  //   login
  // },
  props: {
    getList: {
      type: Function,
      default: null,
    },
    // keyworks:{
    //   type:String,
    //   default: null
    // }
  },
  data() {
    return {
      keyworks: localStorage.getItem('keyworks'),
      biaoTi: localStorage.getItem('biaoti'),
      gray: this.$store.getters.gray,
      dataTheme: this.$store.getters.dataTheme,
      templates: this.$store.getters.templates,
      bannerUrl: '',
      tokenn: getInfo('tokens'), // 判断是否登录
      person: '',
      moovflag: false, //当鼠标移入手机app是显示左边二维码
      backflag: true,
      activeindex: 0,
      navs: [
        {
          path: '/home',
          title: '首页',
        },
        {
          path: '/mooc',
          title: '微警校',
        },
        {
          path: '/sourceslist',
          title: '资源管理',
        },
        {
          path: '/exam',
          title: '考试管理',
        },
        {
          path: '/train',
          title: '调训管理',
        },
        {
          path: '/diaoa',
          title: '教官库',
        },
        {
          path: '/certificate',
          title: '电子证书',
        },
        {
          path: '/diaoy',
          title: '问卷测评',
        },
      ],
      showFlag: true,
      prevImg01: require('@/assets/images/home/loginicon.png'),
      prevImg02: require('@/assets/images/home/reginicon.png'),
      prevImg03: require('@/assets/images/home/phoneapp.png'),
      prevImg04: require('@/assets/images/home/packup.png'),
    };
  },

  methods: {
    acticein(index) {
      this.activeindex = index;
    },
    //搜索
    searcha() {
      if (this.keyworks == null || this.keyworks == '') {
        this.$message({
          message: '警告,搜索不能为空',
          type: 'warning',
        });
      } else if (this.keyworks.length < 2) {
        this.$message({
          message: '警告,至少需要两个字符',
          type: 'warning',
        });
      } else {
        localStorage.setItem('keyworks', this.keyworks);
        localStorage.setItem('Kroute', this.$route.path);
        if (this.$route.path == '/search') {
          this.getList();
        } else {
          this.$router.push({
            path: '/search',
            query: {},
          });
        }
      }
    },
    // 后台管理
    goSystiem() {
      let toke = getInfo('tokens');
      if(!toke){
        window.location.reload();
        return false
      }
      window.open('http://121.12.125.214:2369/index?token=' + toke);
      // window.open('http://localhost:8086/index?token=' + toke);
    },
    // 退出功能
    goOut() {
      var _this = this;
      _this.$confirm('确认退出吗?', '提示', {}).then(() => {
        _this.$store.commit('SET_TOKENS', '');
        _this.$store.commit('SET_INFOS', '');
        removeInfo('infos');
        removeInfo('tokens');
        removeInfo('IDS');
        removeInfo('storageObj');

        _this.$router.push('/home');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      });
    },
    // 点击登录
    clickBtnlist(val) {
      this.$emit(val);
    },
    // 点击切换图片
    changeImageSrc(key, way) {
      let hoverStr = way === 'hover' ? 'active' : '';
      switch (key) {
        case 1:
          this.prevImg01 = require(`@/assets/images/home/loginicon${hoverStr}.png`);
          break;
        case 2:
          this.prevImg02 = require(`@/assets/images/home/reginicon${hoverStr}.png`);
          break;
        case 3:
          this.prevImg03 = require(`@/assets/images/home/phoneapp${hoverStr}.png`);
          this.moovflag = true;
          break;
        case 4:
          this.prevImg04 = require(`@/assets/images/home/packup${hoverStr}.png`);
          this.showFlag = false;
          break;
        case 5:
          this.prevImg05 = require(`@/assets/images/home/packup${hoverStr}.png`);
          this.showFlag = false;
          break;
      }
      if (way == '') {
        this.moovflag = false;
      }
    },
    //点击个人中心跳转到页面
    personCenter() {
      this.$router.push('/personCenter/personhome');
    },
    //点击缩回和放出登录栏
    takeback() {
      this.backflag = !this.backflag;
    },
    grayHandleChange(val) {
      this.$store.dispatch('setGray', val);
    },
    dataThemeHandleChange(val) {
      this.$store.dispatch('setDataTheme', val);
    },
    clickBtn(val) {
      this.$emit(val);
    },
  },
  created() {
    if (this.$route.path !== '/search') {
      localStorage.removeItem('keyworks');
      localStorage.removeItem('Kroute');
    }
    this.bannerUrl = require('@/assets/images/home/headerbanner.png');
    if (this.tokenn) {
      //判断是否登录，是的或取值，没登录取值会报错
      this.person = JSON.parse(getInfo('infos'));

    }
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.header {
  > .head {
    height: 90px;
    font-size: 0;
    @include themeify {
      background: themed('color-background-base');
    }

    > .head-inner {
      width: 1190px;
      height: 90px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .logo-wrap {
        display: flex;
        align-items: center;
        .logo {
          height: 80px;
          margin-right: 10px;
        }

        p {
          margin: 0;
          font-weight: 700;
          font-style: normal;
          font-size: 28px;
          line-height: 28px;
        }

        .txt-title {
          text-align: center;

          span {
            letter-spacing: 30px;
          }
        }

        .txt-url {
          font-size: 26px;
          line-height: 26px;
        }
      }

      > .login {
        height: 40px;
        display: flex;
        align-items: flex-end;

        > span {
          > button {
            @include style-button(normal, mini, false);
          }
        }

        > button {
          margin-left: 20px;
          @include style-button(normal, mini, false);

          + button {
            margin-left: 20px;
            @include style-button(primary, mini, false);
          }
        }
      }
    }
  }

  > .banner {
    width: 100%;
    height: 260px;
    @include style-background-image;
    background-size: 100% 260px;
    position: relative;
    .logoleft {
      height: 100px;
      position: absolute;
      left: 50%;
      margin-left: -60px;
      top: 25px;
    }
    .bannerTitle {
      padding-top: 40px;
      text-align: center;
      .txt-title {
        font-size: 48px;
        display: table-cell;
        text-align: center;
        position: absolute;
        top: 120px;
        left: 50%;
        margin-left: -350px;
        .fonttext {
          display: flex;
          align-items: center;
          margin-left: 150px;
          padding-top: 10px;
          color: #333333;
          font-weight: 700;
          text-shadow: 1px 1px 5px rgba(255, 255, 255, 0.996078431372549);
          opacity: 1;
          line-height: 85px;
        }
        .botn {
          font-size: 20px;
          font-family: '华文中宋 Bold', '华文中宋 Regular', '华文中宋';
          font-weight: 700;
          color: #555;
          text-shadow: 0px 5px 4px rgba(255, 255, 255, 0.38);
          opacity: 1;
          margin-left: 135px;
          margin-top: -8px;
          letter-spacing: 1px;
        }
      }
    }
    .bannerInput {
      display: flex;
      margin: 0 auto;
      width: 460px;
      height: 54px;
      background: #ffffff;
      border-radius: 10px;
      padding-left: 10px;
      margin-top: 190px;
      align-items: center;
      .inputseach {
        display: block;
        flex: 1;
        opacity: 0.89;
        border: 0;

        font-size: 18px;
      }
      .inputimg {
        width: 88px;
        height: 54px;
        text-align: center;
        cursor: pointer;
        line-height: 54px;
        font-size: 18px;
        color: white;
        background: inherit;
        background-color: rgba(203, 24, 32, 1);
        box-sizing: border-box;
        border-width: 1px;
        border-style: solid;
        border-color: rgba(203, 24, 32, 1);
        border-radius: 10px;
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
      }
      .boderle {
        width: 2px;
        height: 40px;
        background-color: #999;
      }
    }

    .txt-url {
      font-size: 26px;
      line-height: 26px;
    }
  }

  > .nav {
    height: 60px;
    box-sizing: border-box;
    border-top: {
      width: 1px;
      style: solid;
    }
    display: flex;
    justify-content: center;

    @include themeify {
      background: themed('color-primary');
      border-top-color: themed('color-border-lighter');
    }

    > ul {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      @include style-ul;

      > li {
        flex: 1 1 100%;
        height: 100%;
        display: inline-flex;
        font-weight: 700;
        font-size: 18px;
        align-items: center;
        justify-content: center;
        transition: 0.3s;
        cursor: pointer;
        color: #fff;
        // @include style-h(4);

        @include themeify {
          color: themed('color-white');
          background: themed('color-primary');
        }

        &:hover,
        &.router-link-active {
          @include themeify {
            color: #fff;
            background: #3c95d6;
            // color: themed('color-text-secondary');
            // background: themed('color-background-base');
            // border-bottom: 2px solid #fff;
          }
        }

        &:hover {
          color: #909399;
          background-color: #ffffff;
        }
      }
    }
  }

  .logsuspend {
    // position: absolute;
    position: fixed;
    right: 40px;
    top: 60px;
    bottom: 48px;
    z-index: 30;

    .logsupendul {
      background-color: #fff;
      .logsupendli {
        width: 86px;
        padding: 5px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #ccc;
        color: #999;
        .logsupendli-center {
          text-align: center;
          width: 100%;
          img {
            display: block;
            width: 32px;
            height: 32px;
            margin: 0 auto;
          }
          span {
            display: block;

            font-size: 14px;
            margin-top: 2px;
          }
        }
        &:hover {
          color: #4876c4;
          cursor: pointer;
        }
      }
      .logsupendli7 {
        border: 0;
        height: 35px;
        img {
          width: 28px;
          height: 28px;
        }
      }
    }
    .arrowsleft {
      width: 24px;
      height: 62px;
      position: absolute;
      left: -24px;
      top: 50%;
      margin-top: auto;
    }
  }
}

.slide-right-enter,
.slide-right-leave-active {
  transform: translateX(120px);
}
.slide-right-leave-active,
.slide-right-enter-active {
  transition: all 0.6s 0.6s cubic-bezier(0.33, 0.25, 0.33, 1);
}

// -----------
.user-defined {
  padding: 10px 0;
}

.user-defined:nth-child(1),
.user-defined:nth-child(2) {
  border-bottom: 1px solid #ddd;
}

.user-defined > .user-defined {
  padding-bottom: 0;
  border-bottom-width: 0;
}
.phoneapp {
  width: 200px;
  height: 200px;
  // background-color: #333;
  background-image: url('../../assets/APP二维码.png');
  background-repeat: no-repeat;
  background-size: cover;
  // position: fixed;
  position: absolute;
  right: 86px;
  top: 90px;
  // left: 79%;
}
.jiantou > img {
  background-color: #ccc;
  border-radius: 5px;
}
.jiantou > img:hover {
  cursor: pointer;
  background-color: rgb(108, 176, 231);
}
</style>
